export default "__VITE_ASSET__d8978ca1__"